<!-- layouts/layoutAsesor.vue -->
<template>
  <main class="layout_asesor">
    <slot />
  </main>
</template>

<script setup>
import { onMounted } from "vue";

const config = useRuntimeConfig()

const debug = {
  enabled: config.public.modo === 'DEV',
  log(...args) {
    if (this.enabled) console.log('[layout_asesor]', ...args)
  },
  error(...args) {
    if (this.enabled) console.error('[layout_asesor]', ...args)
  }
}

const modo_sistema = useState('modo_sistema');

onMounted(() => {
  debug.log("modo_sistema.value: ", modo_sistema.value);
});
</script>